(() => {
  const policyRoot = document.querySelector('.shopify-policy__body > .rte');
  const pageRoot = document.querySelector('.legal-page__content');
  const legalRoot = policyRoot || pageRoot;

  if (!legalRoot) return;

  const createParagraph = (text) => {
    const paragraph = document.createElement('p');
    paragraph.textContent = text;
    return paragraph;
  };

  const normalizeNativePolicy = () => {
    if (!policyRoot) return;

    const children = Array.from(policyRoot.children);
    const firstHeadingIndex = children.findIndex((element) => /^H[1-3]$/.test(element.tagName));

    if (firstHeadingIndex > 0) {
      const preamble = children.slice(0, firstHeadingIndex);
      const clubLine = preamble.find((element) => element.textContent.trim() === 'Stone Roots Olive Oil Club');
      const versionLine = preamble.find((element) => /^Version\s/i.test(element.textContent.trim()));
      const firstHeading = children[firstHeadingIndex];

      if (clubLine && versionLine) {
        const metadata = document.createElement('div');
        metadata.className = 'legal-page__meta';
        metadata.append(clubLine, versionLine);
        firstHeading.before(metadata);
      }

      preamble.forEach((element) => {
        if (element !== clubLine && element !== versionLine && element.isConnected) element.remove();
      });
    }

    const remainingChildren = Array.from(policyRoot.children);
    const lastHeadingIndex = remainingChildren.reduce(
      (index, element, currentIndex) => (/^H[1-3]$/.test(element.tagName) ? currentIndex : index),
      -1
    );
    const footerStartIndex = remainingChildren.findIndex(
      (element, index) => index > lastHeadingIndex && element.textContent.trim() === 'BLOODY ROOTS d.o.o.'
    );

    if (footerStartIndex === -1) return;

    const footerElements = remainingChildren.slice(footerStartIndex);
    const footerText = footerElements.map((element) => element.textContent.trim()).filter(Boolean);
    const registrationLine = footerText.find((line) => /^Registration number/i.test(line)) || '';
    const contactLine = footerText.find((line) => line.includes('@stoneroots.club')) || '';
    const versionText = footerText.find((line) => /^Version\s/i.test(line)) || '';
    const registration = registrationLine.match(/Registration number\s*:?[ ]*([0-9]+)/i)?.[1] || '7331231000';
    const taxNumber = registrationLine.match(/(?:VAT|Tax number)\s*:?[ ]*(?:SI)?([0-9]+)/i)?.[1] || '91306094';
    const email = contactLine.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i)?.[0] || 'jan@stoneroots.club';
    const phone = contactLine.match(/\+386(?:[ ]*[0-9])+/)?.[0] || '+386 40 850 665';
    const address = footerText.find((line) => line.includes('Podbreznik 15')) || 'Podbreznik 15, 8000 Novo mesto, Slovenia';

    const contact = document.createElement('div');
    contact.className = 'legal-page__contact';
    [
      'BLOODY ROOTS d.o.o.',
      address,
      `Registration number: ${registration}`,
      `Tax number: ${taxNumber}`,
      email,
      phone,
      versionText
    ].filter(Boolean).forEach((line) => contact.append(createParagraph(line)));

    footerElements[0].before(contact);
    footerElements.forEach((element) => element.remove());
  };

  const linkify = (root, pattern, hrefForMatch) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || !pattern.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        pattern.lastIndex = 0;
        if (node.parentElement?.closest('a, script, style, code')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];

    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      pattern.lastIndex = 0;
      const fragment = document.createDocumentFragment();
      let cursor = 0;

      for (const match of node.nodeValue.matchAll(pattern)) {
        fragment.append(node.nodeValue.slice(cursor, match.index));
        const link = document.createElement('a');
        link.href = hrefForMatch(match[0]);
        link.textContent = match[0];
        fragment.append(link);
        cursor = match.index + match[0].length;
      }

      fragment.append(node.nodeValue.slice(cursor));
      node.replaceWith(fragment);
    });
  };

  const normalizeSellerDetails = () => {
    const paragraphs = Array.from(legalRoot.querySelectorAll('p'));
    const start = paragraphs.find((paragraph) => paragraph.textContent.trim() === 'Seller / trader:');
    const end = paragraphs.find((paragraph) => paragraph.textContent.trim().startsWith('Telephone:'));

    if (!start || !end || start.parentElement !== end.parentElement) return;

    const siblings = Array.from(start.parentElement.children);
    const startIndex = siblings.indexOf(start);
    const endIndex = siblings.indexOf(end);

    if (startIndex === -1 || endIndex < startIndex) return;

    const details = document.createElement('div');
    details.className = 'legal-page__details';
    start.before(details);
    siblings.slice(startIndex, endIndex + 1).forEach((element) => details.append(element));
  };

  normalizeNativePolicy();
  normalizeSellerDetails();
  document.body.classList.add('legal-pages-normalized');
  linkify(legalRoot, /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, (email) => `mailto:${email}`);

  legalRoot.querySelectorAll('.legal-page__contact, .legal-page__details').forEach((group) => {
    linkify(group, /\+386(?:[ ]*[0-9])+/g, (phone) => `tel:${phone.replace(/\s/g, '')}`);
  });
})();
